// Ponto central e unico da apresentacao de status no frontend (Etapa 4,
// estendido no Backoffice/Etapa E) - usado pelo card da lista, pelo
// dialogo de detalhe e pelos botoes de acao. Isto e SO apresentacao
// (rotulo, cor, quais botoes mostrar) - a maquina de estados de verdade e
// a da API (api/src/constants/statusTransitions.ts, Etapa 3/B). O backend
// valida toda transicao de novo, mesmo que a UI so mostre botoes
// "validos" - esconder um botao aqui e so UX, nunca seguranca.
import { i18n } from "../../translate/i18n";
import { transitionsForDemand } from "./actionMatrix";

// "created" usa o MESMO rotulo/cor de "in_progress" - decisao aprovada: na
// UI, "created" e apresentado como "Em Andamento" (o status tecnico
// continua existindo no backend, para nao migrar/perder os registros
// reais ja criados com ele).
export const STATUS_LABELS = {
	created: () => i18n.t("solicitacoes.status.in_progress"),
	in_progress: () => i18n.t("solicitacoes.status.in_progress"),
	waiting_btg: () => i18n.t("solicitacoes.status.waiting_btg"),
	waiting_assessor_client: () => i18n.t("solicitacoes.status.waiting_assessor_client"),
	btg_refused: () => i18n.t("solicitacoes.status.btg_refused"),
	completed: () => i18n.t("solicitacoes.status.completed"),
	cancelled: () => i18n.t("solicitacoes.status.cancelled"),
};

export const STATUS_COLORS = {
	created: { background: "#FBF0DE", color: "#B4740E" },
	in_progress: { background: "#FBF0DE", color: "#B4740E" },
	waiting_btg: { background: "#FBF0DE", color: "#B4740E" },
	waiting_assessor_client: { background: "#EDE7F6", color: "#5E35B1" },
	btg_refused: { background: "#FDE8E8", color: "#C0392B" },
	completed: { background: "#E6F7F1", color: "#0E9F6E" },
	cancelled: { background: "#FBEAE8", color: "#C0392B" },
};

export const statusLabel = status =>
	STATUS_LABELS[status] ? STATUS_LABELS[status]() : status;

export const statusColor = status =>
	STATUS_COLORS[status] || { background: "#EEF2F7", color: "#4B5768" };

// Backoffice, Etapa G - as transicoes disponiveis dependem da DEMANDA
// (alem de status+perfil, ja existentes desde a Etapa 3/4). A tabela em si
// mora em actionMatrix.js (DEMANDA -> STATUS -> transicoes), com fallback
// generico para as demandas ainda sem regra definida - ver esse arquivo
// para o raciocinio completo. Aqui so consome. `demandName` e opcional:
// omitido, cai automaticamente no comportamento generico (compatibilidade
// com qualquer chamada antiga que ainda nao passe esse parametro).
//
// waiting_btg -> cancelled e a unica transicao que depende de quem esta
// pedindo, nao so do estado atual (regra da Etapa 3, nao ampliada nesta
// etapa) - essa regra e a mesma para qualquer demanda, por isso continua
// fora da matriz por demanda.
export const availableTransitions = (status, profile, demandName) => {
	const transitions = transitionsForDemand(demandName);
	return (transitions[status] || []).filter(target => {
		if (status === "waiting_btg" && target === "cancelled") {
			return profile === "admin";
		}
		return true;
	});
};

export const isTerminal = (status, demandName) =>
	(transitionsForDemand(demandName)[status] || []).length === 0;

// Rotulo do BOTAO de uma transicao - depende de origem+destino, nao so do
// destino (ex.: "in_progress" e alcancado tanto de "created" - "Iniciar
// atendimento" - quanto de "waiting_assessor_client" - "Retomar
// atendimento" - com textos diferentes para a mesma transicao-alvo). Cai
// no rotulo do status-destino (comportamento historico da Etapa 4) quando
// nao ha um texto especifico definido para o par origem/destino.
const SPECIFIC_ACTION_LABELS = {
	"in_progress->waiting_assessor_client": () =>
		i18n.t("solicitacoes.detail.actions.solicitarInformacao"),
	"waiting_assessor_client->in_progress": () =>
		i18n.t("solicitacoes.detail.actions.retomarAtendimento"),
	"waiting_btg->in_progress": () =>
		i18n.t("solicitacoes.detail.actions.retomarAtendimento"),
	"waiting_btg->btg_refused": () => i18n.t("solicitacoes.detail.actions.registrarRecusa"),
};

export const actionLabel = (from, to) => {
	const specific = SPECIFIC_ACTION_LABELS[`${from}->${to}`];
	if (specific) return specific();
	return i18n.t(`solicitacoes.detail.actions.${to}`);
};
